import { render, staticRenderFns } from "./kafa-form-confirmation.vue?vue&type=template&id=74305b0b&scoped=true&lang=pug"
import script from "./kafa-form-confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./kafa-form-confirmation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./kafa-form-confirmation.vue?vue&type=style&index=0&id=74305b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74305b0b",
  null
  
)

export default component.exports